import { useEffect, useRef, useState } from "react";
import { FaSearch, FaTimes, FaUser } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { get } from "../http/api";
import { getMediaUrl } from "../http/media";

export default function NativeSearch() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => { inputRef.current?.focus(); }, []);

  useEffect(() => {
    if (!query.trim()) {
      setResults([]);
      setLoading(false);
      return undefined;
    }
    const timer = window.setTimeout(async () => {
      try {
        setLoading(true);
        const response = await get(`users/search?q=${encodeURIComponent(query.trim())}`);
        setResults(Array.isArray(response?.data) ? response.data : []);
      } catch (error) {
        console.error("Native search error:", error);
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 300);
    return () => window.clearTimeout(timer);
  }, [query]);

  return (
    <section className="native-search-page">
      <header className="native-page-header native-search-title">
        <span />
        <h1>{t("navbar.searchUser")}</h1>
        <span />
      </header>
      <div className="native-search-field">
        <FaSearch />
        <input ref={inputRef} value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t("navbar.searchUser")} />
        {query && <button type="button" onClick={() => setQuery("")}><FaTimes /></button>}
      </div>
      <div className="native-search-results">
        {loading && <p className="native-search-state">{t("navbar.searching")}</p>}
        {!loading && query && results.length === 0 && <p className="native-search-state">{t("navbar.userNotFound")}</p>}
        {results.map((user) => (
          <button type="button" className="native-search-user" key={user.id || user.username} onClick={() => navigate(`/user/${user.username}`)}>
            <span className="native-search-avatar">{user.image ? <img src={getMediaUrl(user.image)} alt="" /> : <FaUser />}</span>
            <span><strong>{user.name || user.username}</strong><small>@{user.username}</small></span>
          </button>
        ))}
      </div>
    </section>
  );
}
